import { type MainButton } from '@tma.js/sdk-react';

export const disableBgColor = '#2c2c2e';
export const disableTextColor = '#808082';
export const activeBgColor = '#210784';
export const activeTextColor = '#ffffff';

export function disableMainButton(mainButton?: MainButton | null) {
  mainButton?.setBgColor(disableBgColor);
  mainButton?.setTextColor(disableTextColor);
  mainButton?.disable();
}

export function enableMainButton(mainButton?: MainButton | null) {
  mainButton?.setBgColor(activeBgColor);
  mainButton?.setTextColor(activeTextColor);
  mainButton?.enable();
}
